export default {
  "id": "9cd1c9a5ad0d201d0699189cdefddcbc",
  "tags": {},
  "filePath": "/Users/malcolmkee/side-project/react-json-friendly-viewer/packages/react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
  "description": "Displays any json data in user-friendly table.\n\nUnspecified props will be spread to the underlying `div` element.",
  "displayName": "JsonPrettyViewer",
  "methods": [],
  "props": {
    "json": {
      "defaultValue": null,
      "description": "",
      "name": "json",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": true,
      "type": {
        "name": "any"
      },
      "tags": {}
    },
    "formatter": {
      "defaultValue": null,
      "description": "",
      "name": "formatter",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "Partial<Formatter>",
        "value": [
          {
            "value": "Partial<Formatter>",
            "description": "",
            "fullComment": "",
            "tags": {}
          }
        ]
      },
      "tags": {}
    },
    "fieldLabel": {
      "defaultValue": {
        "value": "FIELD"
      },
      "description": "",
      "name": "fieldLabel",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "string",
        "value": [
          {
            "value": "string"
          }
        ]
      },
      "tags": {}
    },
    "valueLabel": {
      "defaultValue": {
        "value": "VALUE"
      },
      "description": "",
      "name": "valueLabel",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "string",
        "value": [
          {
            "value": "string"
          }
        ]
      },
      "tags": {}
    },
    "mergePrimitiveArray": {
      "defaultValue": {
        "value": true
      },
      "description": "",
      "name": "mergePrimitiveArray",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "boolean",
        "value": [
          {
            "value": "false"
          },
          {
            "value": "true"
          }
        ]
      },
      "tags": {}
    },
    "renderValue": {
      "defaultValue": {
        "value": "(val) => val"
      },
      "description": "",
      "name": "renderValue",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "((value: string) => ReactNode)",
        "value": [
          {
            "value": "(value: string) => ReactNode",
            "description": "",
            "fullComment": "",
            "tags": {}
          }
        ]
      },
      "tags": {}
    },
    "renderToggleIcon": {
      "defaultValue": {
        "value": "(expanded: boolean) => (\n\t<ToggleIcon expanded={expanded} />\n)"
      },
      "description": "",
      "name": "renderToggleIcon",
      "parent": {
        "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
        "name": "JsonPrettyViewerProps"
      },
      "declarations": [
        {
          "fileName": "react-json-friendly-viewer/src/json-pretty-viewer/json-pretty-viewer.tsx",
          "name": "JsonPrettyViewerProps"
        }
      ],
      "required": false,
      "type": {
        "name": "enum",
        "raw": "((expanded: boolean) => ReactNode)",
        "value": [
          {
            "value": "(expanded: boolean) => ReactNode",
            "description": "",
            "fullComment": "",
            "tags": {}
          }
        ]
      },
      "tags": {}
    }
  }
}